import { IkasAmountType } from "../../../models/order/adjustment";

export type IkasCampaignOfferProduct = {
  countdownMinutes: number | null;
  description: string | null;
  discountAmount: number | null;
  discountType: IkasAmountType | null;
  excludedVariantIdList: string[] | null;
  id: string;
  order: number;
  productId: string;
  showCriteria: IkasCampaignOfferProductShowCriteria | null;
  skipOfferIfProductExistsInCart: boolean | null;
  title: string;
  translations: IkasCampaignOfferProductTranslation[] | null;
};

export type IkasCampaignOfferProductTranslation = {
  description: string | null;
  locale: string;
  title: string;
};

export enum IkasCampaignOfferProductShowCriteria {
  PREVIOUS_ACCEPTED = "PREVIOUS_ACCEPTED",
  PREVIOUS_REJECTED = "PREVIOUS_REJECTED",
}
